/* cr-stock.js: a live "N of 100 left" counter. Portable, data-attribute driven.

   <div data-stock data-stock-url="/products/<handle>?view=stock" data-stock-of="100">
     <strong data-stock-n>39</strong> ...
     <span class="stock__fill" style="--k:.39"></span>
   </div>

   The page is page-cached, so the Liquid number can be stale. This reads
   data-stock-url, the cultracing-stock Worker (stock-worker/), which asks the
   Admin API and so is exact; the storefront's own count trails it by up to a
   minute in a rush. If the Worker fails it falls back to data-stock-fallback,
   templates/product.stock.liquid. Both answer {"<variant id>": qty}. It reads: on load, every 10s while the tab is visible, and 3s
   after an Add to bag. At 0 the block reads sold out and the page's Add to
   bag buttons disable; Shopify's DENY policy already blocks the oversell.
   data-stock-buttons (a CSS selector) names the buttons to disable, for a page
   with more than one product (a drop rack: snippets/cr-stock-bar.liquid). Without
   it, the product page's own buttons, as on Memoria Cult. */
(function () {
  function init(el) {
    var url = el.getAttribute('data-stock-url');
    var fallback = el.getAttribute('data-stock-fallback');
    var of = parseInt(el.getAttribute('data-stock-of'), 10) || 0;
    var n = el.querySelector('[data-stock-n]');
    var fill = el.querySelector('.stock__fill');
    var btnSel = el.getAttribute('data-stock-buttons') || '.product__buy .size-btn';
    var last = null, busy = false;
    function show(left) {
      if (left === last) return;
      if (last !== null) { el.classList.remove('is-tick'); void el.offsetWidth; el.classList.add('is-tick'); }
      last = left;
      n.textContent = left;
      if (fill && of) fill.style.setProperty('--k', Math.max(0, Math.min(1, left / of)));
      el.setAttribute('data-state', left > 0 ? (left <= 10 ? 'low' : 'on') : 'out');
      if (left <= 0) {
        var btns = document.querySelectorAll(btnSel);
        for (var i = 0; i < btns.length; i++) { btns[i].disabled = true; btns[i].classList.add('is-out'); btns[i].textContent = 'Sold out'; }
      }
    }
    function pull() {
      if (busy || document.visibilityState === 'hidden') return;
      busy = true;
      function get(u) {
        return fetch(u + (u.indexOf('?') < 0 ? '?' : '&') + '_=' + Date.now(), { credentials: 'omit', cache: 'no-store' })
          .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); });
      }
      get(url)
        .catch(function () { return fallback ? get(fallback) : Promise.reject(); })
        .then(function (t) {
          var d = JSON.parse(t), left = 0;
          for (var k in d) if (d[k] > 0) left += d[k];
          show(left);
        })
        .catch(function () {})
        .then(function () { busy = false; });
    }
    show(parseInt(n.textContent, 10) || 0);
    pull();
    setInterval(pull, 10000);
    document.addEventListener('visibilitychange', pull);
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.size-btn')) setTimeout(pull, 3000);
    });
  }
  function boot() {
    var all = document.querySelectorAll('[data-stock]');
    for (var i = 0; i < all.length; i++) init(all[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
